export default {
  // 搜索
  searchPlaceholder: "搜索地址/哈希/調證用戶ID",
  dataDetails: "數據詳情",

  // 頁面標題
  userDetails: "用戶詳情",

  // 按鈕
  surveyReport: "調證報告",
  joinCanvas: "加入畫布",
  downloadSurveyFile: "下載調證文件",

  // 加載
  loading: "拼命加載中",

  // 消息提示
  noAddressFound: "沒有查出該地址",
};
